import { LOGIN_NAME } from '@/router/constant';

/**
 * layout布局之外的路由
 * 如登录页、大屏页、toC门户页等需要单独展示，不需要嵌套到后台管理框架的页面
 * 如果不需要验证token权限，请到constant.js中白名单name
 *
 * openType  fullScreen:内部全屏  EXTERNAL:外部打开全屏
 * */

export const outsideLayoutRoutes = [
  {
    path: '/leadership',
    name: 'leadershipDashboard',
    component: () => import('@/views/leadership/index.vue'),
    meta: { title: '领导驾驶舱', openType: 'fullScreen' },
  },
  {
    path: '/',
    name: LOGIN_NAME,
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: {
      title: '登录',
      openType: 'fullScreen', // 必写
    },
  },
  // 嵌套路由示例
  // {
  //   path: '/out',
  //   name: 'out',
  //   component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
  //   meta: {
  //     title: 'out1',
  //     openType: 'fullScreen',
  //   },
  //   children: [
  //     {
  //       path: '/out1',
  //       name: 'out1',
  //       component: () =>
  //         import(/* webpackChunkName: "login" */ '@/views/systemManage/postManage/index.vue'),
  //       meta: {
  //         title: 'out2',
  //         openType: 'EXTERNAL',
  //       },
  //     },
  //   ],
  // },
];
